import React from "react";
import { cancelButton } from "../../common/svg";
import { CustomModalProps } from "../../service/interfaces/Components";
import SecureImage from "../../components/BucketImage/Image";

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  title,
  content,
  onClose,
  width,
  titleColor,
  titleSize,
  titleWeight,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: width || "400px", // Default width if not provided
          background: "white",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between ">
          {/* Title */}
          {title && (
            <div
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                flex: 1, // Allows the title to take up remaining space
                color: titleColor || "#000", // Default color if not provided
              }}
            >
              {title}
            </div>
          )}

          {/* Close Button */}
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              padding: 0,
              marginLeft: title ? "16px" : "auto", 
            }}
          >
            <SecureImage
              fileKey={cancelButton}
              alt="close"
              width="24px"
            />
          </button>
        </div>

        {/* Modal Content */}
        <div
          style={{
            marginBottom: "16px",
          }}
        >
          {content}
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
